// extracted by mini-css-extract-plugin
module.exports = {"categories":"styles_categories__1M65Q","category":"styles_category__2qBn7","subDiv":"styles_subDiv__fxwMa","background":"styles_background__keTQb","scroll":"styles_scroll__fU1X_"};